/**
 * IMPORTANT - You should use this function ONLY when you have no way to check dependency readiness.
 * Purpose - This is a simple retry function to auto retry the function call in sync.
 * Use case - when you need to call a function but its dependency is not ready.
 * No return is supported.
 * @param {*} fn
 * @param {*} maxTimes
 * @param {*} intervalMs
 * @param  {...any} args
 */
export function retryFnCall(fn, maxTimes, intervalMs, ...args) {
  try {
    fn(...args);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`Function call is failure. Retry remaining time: ${maxTimes}: `, error);
    // eslint-disable-next-line no-param-reassign
    if (--maxTimes === 0) {
      throw new Error(error);
    }
    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      retryFnCall(fn, --maxTimes, intervalMs, args);
    }, intervalMs);
  }
}
